import React from 'react';
import './Skills.css';
import { experience } from '../../data';
import SkillCard from './SkillCard';

const Skills = () => {
  return (
    <section id='skill'>
      <div className="section__wrapper">
        <div className="section__header center">
          <h2 className="primary__title">My Skills</h2>
          <p className="text__muted description">
          Full Stack Development: Proficient in frontend backend ,database entegrations and more...  
          I create visually appealing interfaces and scalable solutions.
          </p>
        </div>
        <div className="skill__container">
          {experience.map((list, index) => {
            return (
              <SkillCard
                {...list}
                key={index}
              />
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Skills;